import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
/* Traductor */
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContenedorComponent } from './elements/contenedor/contenedor.component';
import { MenuComponent } from './elements/menu/menu.component';
import { provideHttpClient, withFetch } from '@angular/common/http';
//Librerias de angular material
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatDialogModule} from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatDividerModule} from '@angular/material/divider';
import { MatInputModule} from '@angular/material/input';
import { MatPaginatorModule} from '@angular/material/paginator';
import { MatTableModule} from '@angular/material/table';
import { MatCheckboxModule} from '@angular/material/checkbox';
import { MatRadioModule} from '@angular/material/radio';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatButtonModule} from '@angular/material/button';
import { MatSelectModule} from '@angular/material/select';
import { MatChipsModule} from '@angular/material/chips';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatToolbarModule } from '@angular/material/toolbar';

import { LoginModule } from './login/login.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { InicioComponent } from './elements/inicio/inicio.component';
import { OperativoModule } from './elements/operativo/operativo.module';
import { OperativoPotencialModule } from './elements/operativo-potencial/operativo-potencial.module';
import { RiesgoCreditoModule } from './elements/riesgo-credito/riesgo-credito.module';
import { FinancieroAlertaModule } from './elements/financiero-alerta/financiero-alerta.module';

import { MessageService, MessageDoneComponent, MessageWaitComponent, MessageErrorComponent } from './services/riesgo-credito/base/message.service';

import { APOLLO_NAMED_OPTIONS, ApolloModule, NamedOptions } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { FormulacionModule } from './elements/formulacion/formulacion.module';
import { ComercialModule } from './elements/comercial/comercial.module';
import { SeguimientoModule } from './elements/seguimiento/seguimiento.module';
import { ReportesModule } from './elements/reportes/reportes.module';
import { AdministradorModule } from './elements/administrador/administrador.module';
import { AdministradorGestionModule } from './elements/administrador-gestion/administrador-gestion.module';
import { CuestionariosModule } from './elements/cuestionarios/cuestionarios.module';
import { ResultadosModule } from './elements/resultados/resultados.module';
import { SPANISH_GANTT_CONFIG } from '../app/config/gantt-config';

import { CaptacionComercialModule } from './elements/captacion-comercial/captacion-comercial.module';
import { ColocacionComercialModule } from './elements/colocacion-comercial/colocacion-comercial.module';
import { environment } from '../environments/environment';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { RiesgoLiquidezModule } from './elements/riesgo-liquidez/riesgo-liquidez.module';
import { MatTreeModule } from '@angular/material/tree';
import { ProyeccFinancierasModule } from './elements/proyecc-financieras/proyecc-financieras.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SeguimientoPresupuestalModule } from './elements/seguimiento-presupuestal/seguimiento-presupuestal.module';
import { ReportesNormativosModule } from './elements/reportes-normativos/reportes-normativos.module';

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { ClimaLaboralModule } from './elements/clima-laboral/clima-laboral.module';

registerLocaleData(localeEs);
export function HttpLoaderFactory( http: HttpClient ){
  return new TranslateHttpLoader(http)
}

@NgModule({
  declarations: [
    AppComponent,
    ContenedorComponent,
    MenuComponent,
    InicioComponent,
    MessageDoneComponent,
    MessageWaitComponent,
    MessageErrorComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    //Modulos
    LoginModule,
    OperativoModule,
    OperativoPotencialModule,
    RiesgoCreditoModule,
    FinancieroAlertaModule,
    FormulacionModule,
    SeguimientoModule,
    ReportesModule,
    AdministradorModule,
    ComercialModule,
    AdministradorGestionModule,
    CuestionariosModule,
    ResultadosModule,
    CaptacionComercialModule,
    ColocacionComercialModule,
    RiesgoLiquidezModule,
    ProyeccFinancierasModule,
    SeguimientoPresupuestalModule,
    ReportesNormativosModule,
    ClimaLaboralModule,
    //Angular Mterial
    MatIconModule,
    MatMenuModule,
    MatSidenavModule,
    MatExpansionModule,
    BrowserAnimationsModule,
    MatDialogModule,
    FormsModule,
    MatSnackBarModule,
    MatDividerModule,
    MatInputModule,
    MatPaginatorModule,
    MatTableModule,
    MatCheckboxModule,
    MatRadioModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSelectModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatSlideToggleModule,
    MatListModule,
    MatSliderModule,
    MatTooltipModule,
    MatButtonToggleModule,
    MatGridListModule,
    MatToolbarModule,
    MatTreeModule,
    ReactiveFormsModule,
    NgxSkeletonLoaderModule,
    ...( environment.production
      ?[NgxGoogleAnalyticsModule.forRoot(environment.googleAnalytics)]
      : []
     ),
    /* translate */
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [ HttpClient ]
      }
    }),
    BrowserModule,
    ApolloModule,
    HttpClientModule,
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'es'},
    SPANISH_GANTT_CONFIG,
    provideClientHydration(),
    provideHttpClient(withFetch()),
    provideAnimationsAsync(),
    MessageService,{
      provide: APOLLO_NAMED_OPTIONS,
      useFactory(httpLink: HttpLink):NamedOptions {
        return {
          //Entorno desarrollo
          alertaTempranaDev:{
            cache: new InMemoryCache(),
            link: httpLink.create({
              uri: 'https://dev.api.early-alert.aleema.friedrichlatam.com/api/gql',
            }),
          },
          aleemaRiesgosDev:{
            cache: new InMemoryCache(),
            link: httpLink.create({
              uri: 'https://dev-api.riesgos.aleema.rflatina.com/gql',
            }),
          },
          cuestionariosDev:{
            cache: new InMemoryCache(),
            link: httpLink.create({
              uri: 'https://dev.api.survey.aleema.friedrichlatam.com/api/gql',
            }),
          },
          comercialDev:{
            cache: new InMemoryCache(),
            link: httpLink.create({
              uri: 'https://dev.api.commercial.aleema.friedrichlatam.com/api/gql',
            }),
          },
          aleemaRiesgosDevC:{
            cache: new InMemoryCache(),
            link: httpLink.create({
              uri: 'https://dev.api.risks.coopeduc.aleema.friedrichlatam.com/api/gql',
            }),
          },
          aleemaRiesgosGeneralDev:{
            cache: new InMemoryCache(),
            link: httpLink.create({
              uri: 'https://dev.api.risk.aleema.friedrichlatam.com/gql',
            }),
          },          
          gestionDev:{
            cache: new InMemoryCache(),
            link: httpLink.create({
              uri: 'https://dev.api.gestion-estrategica.aleema.friedrichlatam.com/api/gql',
              // uri: 'https://api.gestion-estrategica.aleema.friedrichlatam.com/api/gql',
            }),
          },
          gestionProd:{
            cache: new InMemoryCache(),
            link: httpLink.create({
              uri: 'https://api.gestion-estrategica.aleema.friedrichlatam.com/api/gql',
            }),
          },
          //Entorno producción
          aleemaRiesgosProC:{
            cache: new InMemoryCache(),
            link: httpLink.create({
              uri: 'https://api.risks.coopeduc.aleema.friedrichlatam.com/api/gql',
            }),
          },
          aleemaRiesgosGeneralPro:{
            cache: new InMemoryCache(),
            link: httpLink.create({
              uri: ' https://api.credit-risks.aleema.friedrichlatam.com/gql',
            }),
          }, 
          alertaTempranaPro:{
            cache: new InMemoryCache(),
            link: httpLink.create({
              uri: 'https://api.early-alert.aleema.friedrichlatam.com/api/gql',
            }),
          },          
          cuestionariosPro:{
            cache: new InMemoryCache(),
            link: httpLink.create({
              uri: 'https://api.survey.aleema.friedrichlatam.com/api/gql',
            }),
          },
          comercialPro:{
            cache: new InMemoryCache(),
            link: httpLink.create({
              uri: 'https://api.commercial.aleema.friedrichlatam.com/api/gql',
            }),
          },
        };
      },
      deps: [HttpLink],
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
